import { FC } from 'react';
import { Footer } from 'layouts/Footer';
import { Helmet } from 'react-helmet-async';
import { TPublicPageProps } from './types';

export const PublicPage: FC<TPublicPageProps> = ({ children, title }) => {
	return (
		<div className="wrapper">
			<Helmet>
				<title>{title}</title>
			</Helmet>
			<main
				className="main"
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: 1,
					minHeight: 'calc(100vh - 70px)',
				}}
			>
				<div
					className="main-content"
					style={{
						display: 'flex',
						flex: 1,
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					{children}
				</div>
			</main>
			<Footer />
		</div>
	);
};
